import React, { useState, useEffect } from "react";
import Helpers from "../../helpers/shared.helper";
import Storage from "../../services/storage.service";
import Settings from "../../services/settings.service";
import Translations from '../../services/translation.service';
import OtpScreen from "../shared/otp-screen/otpScreen";
import SimDeactivationService from "../../services/sim-deactivation.service";

const subscriptions = [];
const SimDeactivationOTP = (props) => {
    const { history } = props;
    const [translationKeys, setTranslationsKeys] = useState(
        Translations.keys ? Translations.keys : {}
    );
    // Initialize state with default value
    const [formValues, setFormValues] = useState({});
    const [otpData, setOtpData] = useState({
        otpError: false,
        otpForm: {
            formValid: false,
            otp: {
                value: "",
                tuched: false,
                validation: false,
                rules: Settings.formats.otpCodeWithoutLength,
                required: true,
            },
        }}
    )
    const [OTPLength, setOTPLength] = useState(6);
    const [OTPTimer, setOTPTimer] = useState(30);
    const [loading, setLoading] = useState(false);
    
    useEffect(() => {
        setOTPLength(Helpers.getOTPLength("otp_sim_deactivation_length"));
        setOTPTimer(Helpers.getOTPTimer("resend_otp_timer"));
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        // Check if state exists in history.location and set the data accordingly
        if (history?.location?.state && history?.location?.state?.formValues) {
            setFormValues(history?.location?.state?.formValues);
        }
    }, [history.location.state]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        subscriptions.push(
        Translations.getKeysObsrv().subscribe((data) => {
            setTranslationsKeys(data);
        })
        );

        return () => {
        if (subscriptions && subscriptions?.length) {
            for (let subscription of subscriptions) {
            subscription.unsubscribe();
            }
        }
        };
    }, []);

    const requestNewOtp = () => {
        setLoading(true);
        let data = null;
        let countryCode = Helpers.getCountryCodePO() || ""; 
        let phoneNumber = formValues.phone.value
        phoneNumber = `${countryCode}${phoneNumber?.replace(/^0+/, '')}`;    
        data = {
            number: phoneNumber,
            reason_id: formValues.deactivationReason.value,
            id_number: formValues.idNumber.value,
            id_type: formValues.idType.value,
        }
        SimDeactivationService.requestOTPForWeb(data)
        .then(response => {
            if (response.data) {
                setLoading(false);
            }
        })
        .catch(() => {
            setLoading(true);
        });
    }

    const otpFormSubmit = () => {
        setLoading(true);
        Storage.clear("genericOTPError");
        Storage.set("genericOTPError", true, true);
        let countryCode = Helpers.getCountryCodePO() || "";
        let data = {
            number: `${countryCode}${formValues?.phone?.value?.replace(/^0+/, '')}`,
            otp: otpData?.otpForm?.otp?.value,
            reason_id: formValues.deactivationReason.value
        }
        Storage.set("deactivationMsisdn", data?.number, true);
        SimDeactivationService.verifyOTP(data)
        .then((res) => {
            if (res) {
                props.history.push({
                    pathname: '/sim-deactivation/absher',
                    state: { formValues: formValues }
                });
                setLoading(false);
            } else {
                setOtpData((prevState) => ({
                    ...prevState,
                    otpError: true
                }));
                setLoading(true);
            }
            Storage.clear("genericOTPError");
        })
        .catch((err) => {
            Storage.clear("genericOTPError");
            setOtpData((prevState) => ({
                ...prevState,
                otpError: true
            }));
            setLoading(false);
        });
    }

    const handleOtpForm = (value) => {
        const updatedState = { ...otpData };
        if (value.length === OTPLength) {
          updatedState.otpForm.formValid = true;
        } else {
          updatedState.otpForm.formValid = false;
          updatedState.otpError = false;
        }
        updatedState.otpForm.otp.value = value;
        setOtpData((prevState) => ({
            ...prevState,
            ...updatedState
        }));
    };

    const handleOtpError = (value) => {
        setOtpData((prevState) => ({
            ...prevState,
            otpError: value,
        }));
    }

    return (
        <>
        <OtpScreen
            onSubmit={otpFormSubmit}
            isFormValid={otpData.otpForm.formValid}
            requestNewOtp={requestNewOtp}
            otpError={otpData.otpError}
            handleOtpForm={handleOtpForm}
            handleOtpError={handleOtpError}
            title={translationKeys["stm_sim_deactivation_otp_verify"]}
            desc={`${translationKeys["stm_sim_deactivation_otp_desc1"] + " "}${OTPLength || 6}${" " + translationKeys["stm_sim_deactivation_otp_desc2"]}`}
            otpLength={OTPLength}
            translationNeeded={false}
            loading={loading}
            timer={OTPTimer}
        />
    </>)
}
export default SimDeactivationOTP;